import ___svg_boldSvg from '../svg/bold.svg';
import { bold as bold_1 } from './bold.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';

const bold: RibbonButton = {
    key: 'bold',
    title: () => loc(bold_1),
    imageSrc: ___svg_boldSvg,
    shortcut: 'ctrl+B',
    buttonState: formatState =>
        formatState.isBold ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: editorViewState => callFormatApi(editorViewState, 'toggleBold'),
};

export default bold;
